import { create } from 'zustand';
import type { DraftLeg } from '../components/ItineraryRow.tsx';

/**
 * In-memory clipboard for travel legs. Mirrors the legacy Home's
 * `copiedItineraryItems` array — copied legs are template drafts
 * (no id / visitorId / groupId) that can be pasted against any target.
 *
 * The clipboard survives navigation between Home and the Groups page so a
 * user can copy from a visitor and paste onto a group, or vice versa.
 */
interface TravelClipboardState {
  items: DraftLeg[];
  set(items: DraftLeg[]): void;
  clear(): void;
}

export const useTravelClipboard = create<TravelClipboardState>(set => ({
  items: [],
  set: items => set({ items }),
  clear: () => set({ items: [] }),
}));
